import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_LANG, T } from "@/i18n/translations";

const LangContext = createContext(null);

const STORAGE = "schock_lang";

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const v = localStorage.getItem(STORAGE);
            if (v && T[v]) return v;
        } catch { /* ignore */ }
        return DEFAULT_LANG;
    });

    useEffect(() => {
        try { localStorage.setItem(STORAGE, lang); } catch { /* ignore */ }
        document.documentElement.lang = lang;
    }, [lang]);

    const value = useMemo(() => ({
        lang,
        setLang,
        t: T[lang] || T[DEFAULT_LANG],
    }), [lang]);

    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
    return ctx;
};
